import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

/**
 * Dialog to show the calculation breakdown for a Price Point using sampleJson from CalcProdPp
 */
export const SamplePpCalcDialog = ({ data, closeDialog }) => {
  // data.sampleJson should be a JSON string
  const [parsedSample, setParsedSample] = useState(null);

  useEffect(() => {
    if (data?.sampleJson) {
      try {
        setParsedSample(JSON.parse(data.sampleJson));
      } catch (e) {
        setParsedSample(null);
      }
    }
  }, [data?.sampleJson]);

  // Extract formula and title

  if (!parsedSample) {
    return <Dialog onClose={closeDialog} open fullWidth maxWidth="md"></Dialog>;
  }

  const { formula, title, ...fields } = parsedSample;

  return (
    <Dialog
      onClose={closeDialog}
      open
      fullWidth
      maxWidth="md"
      slotProps={{
        paper: {
          sx: {
            height: 'auto',
            maxHeight: '80%',
            width: '80%',
            maxWidth: '80%',
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <DialogTitle>
        <Typography align="center" variant="h5">
          {title || 'Price Point Calculation'}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h6" align="center">
            Formula:
          </Typography>
          <Typography variant="subtitle1" sx={{ whiteSpace: 'pre-wrap' }} align="center">
            {formula}
          </Typography>
        </Box>
        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h6" align="center">
            Calculation Inputs:
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {Object.entries(fields).map(([key, value]) => (
              <Typography variant="subtitle1" key={key} align="center">
                {key}: {value}
              </Typography>
            ))}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
